<div class="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-5 p-2 sm:pl-3">
  <div class="flex items-center gap-1">
    <pc-shared-add-to-favorites-button
      [config]="addToFavoritesButtonConfig"
      orientation="vertical"
    ></pc-shared-add-to-favorites-button>
  </div>

  @if (selectImageUrl(header.images ? header.images[0] : null) | async; as imageUrl) {
    @if (!compact) {
      <cat-header-image
        [coreId]="coreId"
        [header]="header"
        [imageUrl]="imageUrl"
        [item]="item"
      ></cat-header-image>
    }
  }

  <div class="flex-auto flex justify-between items-center">
    <cat-header-content
      (action)="action.emit($event)"
      (click)="action.emit(item)"
      [compact]="compact"
      [header]="header"
      [hideSortInHeader]="hideSortInHeader"
      [item]="item"
      [sortString]="sortString"
      [sort]="sort"
      class="cursor-pointer w-full"
      >
    </cat-header-content>

    @if (enableMenu) {
      <button [matMenuTriggerFor]="m.menu" id="catalog_header_btn_open-menu" mat-icon-button>
        <mat-icon>more_vert</mat-icon>
      </button>
    }
  </div>
</div>

@if (enableHighlighting && !compact) {
  <cat-header-highlighting
    [addMargin]="hasAddToFavoritesButton"
    [highlighting]="highlighting"
    [item]="item"
    class="hidden lg:block"
  ></cat-header-highlighting>
}

<cat-header-menu
  #m="menuHeader"
  (compare)="onCompare()"
  (copyUrl)="onCopyUrl()"
  (fullscreen)="fullscreen.emit()"
  (openInBrowser)="onOpenInBrowser()"
  (openOverlay)="openOverlay.emit()"
  (pin)="onPin()"
  [enableFullscreen]="enableFullscreen"
  [enableOverlay]="enableOverlay"
  [enablePin]="enablePin"
  [headerCollapsible]="headerCollapsible"
  [header]="header"
  [isFullscreen]="isFullscreen"
  [item]="item"
></cat-header-menu>
